import { render, staticRenderFns } from "./ContentGridFilter.vue?vue&type=template&id=5afbfcca&scoped=true&shadow"
import script from "./ContentGridFilter.vue?vue&type=script&lang=js&shadow"
export * from "./ContentGridFilter.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentGridFilter.vue?vue&type=style&index=0&id=5afbfcca&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5afbfcca",
  null
  ,true
)

export default component.exports